import type { FC } from "react";
import { OrganizationsPage } from "./OrganizationsPage";

const OrganizationsContainer: FC = () => {
  return <OrganizationsPage />;
};

export default OrganizationsContainer;
